import transactiondetails from "./transactiondetails.js";
import btchashdetail from "./btchashdetail.js";
import addressdetail from "./addressdetail.js";
import addressDetails from "./addressDetails/index.js";
import userDetails from "./userDetails/index.js";

export default {
  transactiondetails,
  btchashdetail,
  addressdetail,
  addressDetails,
  userDetails,
};
